import React, { useState } from 'react';
import { IconProps } from '@phosphor-icons/react';

export const useHoverState = () => {
  const [hoveredKey, setHoveredKey] = useState<string | null>(null);

  const handleMouseEnter = (key: string) => {
    setHoveredKey(key);
  };

  const handleMouseLeave = () => {
    setHoveredKey(null);
  };

  return {
    hoveredKey,
    handleMouseEnter,
    handleMouseLeave,
  };
};

export const getIconWithState = (
  icon: React.ReactElement,
  isSelected: boolean,
  isHovered: boolean,
  selectedWeight: string = 'bold',
  hoveredWeight: string = 'bold',
  normalWeight: string = 'regular',
  color: string = 'var(--primaryColor)',
) => {
  let weight = normalWeight;

  if (isSelected) {
    weight = selectedWeight;
  } else if (isHovered) {
    weight = hoveredWeight;
  }

  return React.cloneElement(
    icon as React.ReactElement<IconProps>,
    {
      weight,
      color,
    } as Partial<IconProps>,
  );
};
